"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerEventWrapper = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var PointerEventAdapter_1 = require("./PointerEventAdapter");
var ReactHelpers_1 = require("./ReactHelpers");
/**
 * Wrap a DOM component to give it pointer events. Example that attaches a click to a div:
 *
 *    React.createElement(PointerEventWrapper, { pointerClick: () => console.log('click') },
 *      React.createElement('div')
 *    )
 *
 * When using, you can only have one child and it must render its props to a DOM component or events will not be attached.
 * If there is more than one child an exception will be thrown.
 */
var PointerEventWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(PointerEventWrapper, _super);
    function PointerEventWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.pointerEventAdapter = PointerEventAdapter_1.PointerEventAdapterManager.adapterFactory();
        return _this;
    }
    PointerEventWrapper.prototype.componentDidMount = function () {
        var _a, _b;
        (_b = (_a = this.pointerEventAdapter).didMount) === null || _b === void 0 ? void 0 : _b.call(_a, ReactDOM.findDOMNode(this), this.props);
    };
    PointerEventWrapper.prototype.componentDidUpdate = function () {
        var _a, _b;
        (_b = (_a = this.pointerEventAdapter).didUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ReactDOM.findDOMNode(this), this.props);
    };
    PointerEventWrapper.prototype.componentWillUnmount = function () {
        if (this.pointerEventAdapter.willUnmount) {
            this.pointerEventAdapter.willUnmount();
        }
    };
    PointerEventWrapper.prototype.render = function () {
        var eventAttributes = this.pointerEventAdapter.getHtmlAttributes(this.props);
        // reuse the child. It could be anything - div, ul, button, etc.
        var child = React.Children.only(this.props.children);
        var mergedEventAttributes = {};
        Object.keys(eventAttributes).forEach(function (eventName) {
            mergedEventAttributes[eventName] = ReactHelpers_1.mergeEventHandlers(eventAttributes[eventName], child.props[eventName]);
        });
        /*
         * Although this class was originally created as a bridge to VizClient TableauEventHandler (i.e. `event-utils`),
         * we have found that it actually works much better to entirely opt-out of that infrastructure and use regular
         * React events. We add `EventUtilsOptout` here in order to make sure that anywhere still using `PointerEventWrapper`
         * doesn't actually end up using `event-utils`.
         */
        var clonedElement = React.cloneElement(child, tslib_1.__assign(tslib_1.__assign({}, mergedEventAttributes), ReactHelpers_1.EventUtilsOptOut));
        return clonedElement;
    };
    return PointerEventWrapper;
}(React.PureComponent));
exports.PointerEventWrapper = PointerEventWrapper;
//# sourceMappingURL=PointerEvents.js.map